import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { billingApi } from "./billingApi";
import { goToCheckout } from "./redirect";
import { payErrorCode } from "./usePayStatement";

const KNOWN_ERRORS = new Set(["not_allowed", "payment_unavailable", "payment_failed"]);

/**
 * "Add card" / "Replace card": open Paymob's checkout to save a card.
 *
 * Nothing is charged by it. The card replaces the one on file when Paymob's
 * signed callback reaches the server, and a bill already waiting is charged
 * to it then — the browser only comes back to `/billing/return?card=1`.
 */
export function useSaveCard() {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: () => billingApi.saveCard(),
    onSuccess: (data) => {
      goToCheckout(data.checkout_url);
    },
    onError: (err: unknown) => {
      const code = payErrorCode(err);
      toast.error(
        code && KNOWN_ERRORS.has(code) ? t(`billing.payError.${code}`) : t("billing.payError.generic"),
      );
    },
  });
}

/** "Visa •••• 4242". */
export function cardLabel(card: { brand: string; last4: string }): string {
  return `${card.brand ? `${card.brand} ` : ""}•••• ${card.last4}`;
}
